export function getRandomLogoColor() {
  const options = ["red", "green", "blue", "yellow"];
  return options[Math.round(Math.random() * (options.length - 1) + 0)];
}
